module.exports = __webpack_public_path__ + "static/media/221-Milo-Monolog_ID_1.58bb9316.mp3";